<template>
  <div>
    <paginated-search v-bind="{ schema, loadingData, searchEntities, exportEntity, autoEnable: true }"></paginated-search>
  </div>
</template>

<script>
import PaginatedSearch from "@/components/Espresso/BackendPaginatedSearch.vue";
import ExpressoAux from "@/components/Espresso/EspressoAux.vue";
import Srq20Email from "@/models/Srq20Email.model.vue";
import { Modal } from '@/components';
import XLSX from 'xlsx';

export default {
  components: {
    PaginatedSearch,
    Modal,
  },
  data() {
    return {
      companies: [],
      articles: [],
      schema: Srq20Email.getSchema(),
      loadingData: Srq20Email.loadingData,
    };
  },
  methods: {
    searchEntities(paginationParameters) {
      console.log('Pesquisar', paginationParameters);

      return Srq20Email.search(paginationParameters);
    },
    exportEntity(parameters) {
      console.log('Download', parameters);

      //Remove Pagination parameters to make the download api call
      delete parameters["orderBy"]
      delete parameters["orderDirection"]

      //Add obrigatory paramenters
      if (!parameters.company) {
        parameters["company"] = 0
      }
      if (!parameters.platform) {
        parameters["platform"] = "ALL"
      }

      if (parameters.dateStart && parameters.dateEnd) {
        //Create the file to download
        if ((parameters.user === "%undefined%"))
          delete parameters["user"]
        this.$validator.validateAll().then(async (result) => {
          if (result) {
            Srq20Email.download(parameters)
              .then((response) => {
                console.log("resp", response)
                if (response.length > 0) {
                  const exportWS = XLSX.utils.json_to_sheet(response);
                  const wb = XLSX.utils.book_new();

                  XLSX.utils.book_append_sheet(wb, exportWS, 'export');

                  // export Excel file
                  XLSX.writeFile(wb, 'SRQ20.xlsx');
                } else {
                  ExpressoAux.showWarningModal("Não foi possível encontrar registros.");
                }

              })
              .catch((error) => {
                console.log("export error", error);
                ExpressoAux.showWarningModal("Não foi possível encontrar registros.");
              });
          } else {
            ExpressoAux.showFailModal("Todos os campos são obrigatorios");
          }
        });
      } else {
        ExpressoAux.showFailModal("Todos os campos são obrigatorios");
      }


    },
  },
  created() {

  }
}
</script>
